/** Riot servers the admin commonly filters on (matches API `Server::getAvailableList`). */
export const ADMIN_SERVERS = ['EUW', 'NA', 'BR'] as const

export type AdminServer = (typeof ADMIN_SERVERS)[number]

export const SERVER_OPTIONS = ADMIN_SERVERS.map((value) => ({ value, label: value }))
